import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type Item = {
  q: string;
  a: string;
};
const faqs: Item[] = [{
  q: '¿Tengo que dejar llorar a mi bebé?',
  a: 'No. El método está diseñado para acompañar cada despertar. La Guía de Consuelo te da las palabras y los pasos exactos para calmarlo sin dejarlo solo.'
}, {
  q: '¿Funciona a cualquier edad?',
  a: 'Está pensado para bebés de 0 a 24 meses. Los horarios y ventanas de sueño vienen separados por rango de edad, así que aplicas solo lo que corresponde al tuyo.'
}, {
  q: '¿Cómo recibo la guía?',
  a: 'Al completar el pago recibes un correo con el enlace de descarga en menos de 2 minutos. Funciona en teléfono, tablet y computadora, y es tuya para siempre.'
}, {
  q: '¿Y si no me funciona?',
  a: 'Tienes 7 días para probarlo. Si no ves una mejora clara, escríbenos y te devolvemos los $6.39 completos, sin preguntas.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="faq-title" data-id="element-16" data-mp="pj95vm1xzdm2">
      <div className="mx-auto max-w-2xl px-5" data-id="element-17" data-mp="ufzke4y3m15d">
        <h2 id="faq-title" className="text-center font-display text-3xl font-black text-slateblue-900 sm:text-4xl" data-id="element-18" data-mp="uey51oa1ushu">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-19" data-mp="kkxvna7qj13b">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="overflow-hidden rounded-2xl border border-slateblue-100 bg-white" data-id="element-20" data-mp="biolilgdp9qg" data-mpi={i}>
                <h3 data-id="element-21" data-mp="3swjyd2ji0pog">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-semibold text-slateblue-900 transition-colors hover:bg-slateblue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-coral" data-id="element-22" data-mp="1sd5w1nc1c3q">
                    {item.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slateblue-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-23" data-mp="1pojk0lqbwbub" />
                  </button>
                </h3>
                {isOpen && <p className="px-5 pb-5 text-[15px] leading-relaxed text-slateblue-600" data-id="element-24" data-mp="2dexhirron2wa">
                    {item.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}